// Skeleton loaders — spinner yerine içerik şekli.
// Tek base <Skeleton> + composite preset'ler (SkeletonText, SkeletonCard, SkeletonTable, SkeletonAvatar).
// Tema değişkenleriyle uyumlu, dependency yok.
import React from 'react';

export default function Skeleton({
  width = '100%',
  height = 16,
  radius = 'var(--r-sm)',
  style = {},
  inline = false,
}) {
  return (
    <span
      style={{
        display: inline ? 'inline-block' : 'block',
        width,
        height,
        borderRadius: radius,
        background:
          'linear-gradient(90deg, var(--bg-tertiary) 0%, var(--bg-card-hover) 50%, var(--bg-tertiary) 100%)',
        backgroundSize: '200% 100%',
        animation: 'skeleton-shimmer 1.2s ease-in-out infinite',
        ...style,
      }}
      aria-hidden="true"
    />
  );
}

export function SkeletonText({ lines = 3, lastLineWidth = '60%', gap = 8 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          width={i === lines - 1 ? lastLineWidth : '100%'}
          height={14}
        />
      ))}
    </div>
  );
}

export function SkeletonAvatar({ size = 36 }) {
  return <Skeleton width={size} height={size} radius="50%" inline />;
}

export function SkeletonCard({ height = 88, lines = 2 }) {
  return (
    <div
      style={{
        padding: 12,
        background: 'var(--bg-card)',
        border: '1px solid var(--border-secondary)',
        borderRadius: 'var(--r-md)',
        minHeight: height,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
        <SkeletonAvatar size={28} />
        <Skeleton width="40%" height={14} />
      </div>
      <SkeletonText lines={lines} />
    </div>
  );
}

export function SkeletonTable({ rows = 6, columns = 5, headerVisible = true }) {
  return (
    <div style={{ width: '100%' }}>
      {headerVisible && (
        <div style={{ ...rowStyle, background: 'var(--bg-tertiary)', borderBottom: '1px solid var(--border-secondary)' }}>
          {Array.from({ length: columns }).map((_, c) => (
            <Skeleton key={'h' + c} width="70%" height={12} />
          ))}
        </div>
      )}
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} style={{ ...rowStyle, borderBottom: '1px solid var(--border-secondary)' }}>
          {Array.from({ length: columns }).map((_, c) => (
            <Skeleton key={r + '-' + c} width={c === 0 ? '50%' : '80%'} height={14} />
          ))}
        </div>
      ))}
    </div>
  );
}

const rowStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
  gap: 12,
  padding: '12px 14px',
};

if (typeof document !== 'undefined' && !document.getElementById('skeleton-keyframes')) {
  const s = document.createElement('style');
  s.id = 'skeleton-keyframes';
  s.textContent = `
    @keyframes skeleton-shimmer {
      0%   { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `;
  document.head.appendChild(s);
}
